import { useState } from 'react'

import AddIcon from '@material-ui/icons/Add'
import GetAppIcon from '@material-ui/icons/GetApp'
import PaymentIcon from '@material-ui/icons/Payment'
import SetState from 'Components/Hooks/SetState'
import NavBarGlobal from 'Components/UI/Molecules/NavBar'
import Export from 'Components/UI/Organisms/Vehicles/SearchVehicles/Export'
import New from 'Components/UI/Organisms/Vehicles/SearchVehicles/New'
import Payments from 'Components/UI/Organisms/Vehicles/SearchVehicles/Payments'
import TableSearchVehicles from 'Components/UI/Organisms/Vehicles/SearchVehicles/Table/index'
import Template from 'Components/UI/Templates/Common'
import { oemColorButton } from 'Helpers'
import { useLocation } from 'react-router-dom'
import { getUbicacion } from 'service/helpers/localstorage'

const TemplateSearchVehicles = () => {
  const { state: payments, setOpen: openPayments, setClose: closePayments } = SetState()
  const { state: add, setOpen: openAdd, setClose: closeAdd } = SetState()
  const { state: download, setOpen: openDownload, setClose: closeDownload } = SetState()

  const location = getUbicacion() || ''
  const { pathname } = useLocation()

  const [render, setRender] = useState(true)
  const [activeButtons, setActiveButtons] = useState({})
  const BUTTONS = [
    {
      menuIcon: <PaymentIcon fontSize="small" />,
      menuTitle: 'Pagos',
      buttonContent: 'Pagos',
      onClick: openPayments,
      disabled: !activeButtons.payments,
    },
    {
      menuIcon: <GetAppIcon fontSize="small" />,
      buttonContent: <GetAppIcon />,
      menuTitle: 'Exportar',
      onClick: openDownload,
      disabled: !activeButtons.export,
    },
    {
      menuIcon: <AddIcon fontSize="small" />,
      buttonStartIcon: <AddIcon fontSize="small" />,
      menuTitle: 'Nuevo',
      onClick: openAdd,
      buttonContent: 'Nuevo',
      buttonStyle: activeButtons.create ? oemColorButton(pathname, location) : {},
      disabled: !activeButtons.create,
    },
  ]

  return (
    <>
      <Template
        navbar={
          <NavBarGlobal buttons={BUTTONS} title="Vehículos" subTitle="Listado de vehículos" />
        }
        table={
          <TableSearchVehicles
            render={render}
            setRender={setRender}
            setActiveButtons={setActiveButtons}
          />
        }
      />

      {payments.suspense && (
        <Payments
          open={payments.open}
          close={closePayments}
          setRender={setRender}
          render={render}
        />
      )}

      {add.suspense && (
        <New open={add.open} handleClose={closeAdd} render={render} setRender={setRender} />
      )}
      {download.suspense && <Export open={download.open} close={closeDownload} />}
    </>
  )
}

export default TemplateSearchVehicles
